import {RouterModule, Routes} from '@angular/router';

import {AuthenticationGuard} from '@modweb5/sharedQuards/authentication.guard';



const routes: Routes = [
	{
		path: '', 
		redirectTo: 'app', 
		pathMatch: 'full'
	},
	{
		path: 'login',
		loadChildren: () => import('../../../../libs/shared/modules/login/login.module').then(m => m.LoginModule)
	},
	{
		path: 'app',
		loadChildren: () => import('../application/application.module').then(m => m.ApplicationModule),
		canActivate: [AuthenticationGuard]

	},
	{
		path: '**', 
		redirectTo: 'app'
	}
];

export const routing = RouterModule.forRoot(routes, { enableTracing: false, useHash: true });
		